"use client";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { z } from "zod";
import { useMemo } from "react";
import DynamicForm from "@/components/dynamicForm";
import { useLocale } from "next-intl";
import { useRouter } from "@/i18n/navigation";
import { getLocalizedPath } from "@/utils/pathUtils";
import { useAnalyticsContext, TrackingEvent, ProductType } from "@/analytics";

const PnrForm = ({ onClose }) => {
  const t = useTranslationDetector("hotel");
  const router = useRouter();
  const { locale } = useLocale();
  const { dispatch } = useAnalyticsContext();
  const schema = useMemo(() => (
    z.object({
      pnrCode: z
        .string()
        .trim()
        .min(1, t("pnrFormPnrCodeRequired"))
        .max(20, t("pnrFormPnrCodeTooLong")),
      productType: z
        .string()
        .optional(),
      surname: z
        .string()
        .trim()
        .min(1, t("pnrFormSurnameRequired"))
        .max(50, t("pnrFormSurnameTooLong")),
    })
  ), [t]);
  const reservationUrl = getLocalizedPath('/reservation/[hashCode]', locale);
  return (
    <div className="pb-8">
      <DynamicForm
        schema={schema}
        endpoint="/api/reservation/pnr"
        defaultValues={{ productType: "Hotel", pnrCode: "", surname: "" }}
        onSuccess={(res) => {
          dispatch({
            type: TrackingEvent.CHECK_RESERVATION,
            payload: {
              productType: ProductType.HOTEL,
              pnr_number: res?.code ?? "",
              reservation_category: "hotel",
            },
          });
          const url = reservationUrl.replace('[hashCode]', res?.code || '');
          router.push(url);
          onClose();
        }}
        onError={(msg) => {
          // Optional: extra side effects on error
          console.warn("PNR Search error:", msg);
        }}
        className="space-y-4"
      >
        <DynamicForm.Error className="rounded bg-red-50 px-3 py-2 text-sm text-red-700" />

        <DynamicForm.Field
          name="pnrCode"
          type="text"
          placeholder={t("pnrFormPnrCode2")}
          inputClassName="font-normal text-foreground-subtle"
        />
        <div className="hidden">
          <DynamicForm.Field
            name="productType"
            type="hidden"
          />
        </div>
        <DynamicForm.Field
          name="surname"
          type="text"
          placeholder={t("pnrFormSurname")}
          inputClassName="font-normal text-foreground-subtle"
        />

        <div className="flex flex-col gap-2">
          <DynamicForm.Button
            spanClassName="h-[50px] flex items-center justify-center text-center font-medium"
            className="flex-1 rounded-lg bg-primary px-4 text-white hover:bg-primary/90"
          >
            {t("pnrFormSubmit")}
          </DynamicForm.Button>

          <div className="mt-1 text-[16px] inline" style={{ color: "#585B5E" }}>
            {t("pnrFormHelpText")}{" "}
            <button
              type="button"
              className="text-[#01007F] underline p-0 m-0 bg-transparent border-0 cursor-pointer font-inherit text-[16px]"
              style={{ verticalAlign: "baseline", display: "contents" }}
              onClick={() => {
                // TODO: Yardım bağlantısı/aksiyonu
              }}
            >
              <span className="underline">
                {t("pnrFormCantFindLink")}
              </span>
            </button>
          </div>

        </div>
      </DynamicForm>
    </div>
  );
};

export default PnrForm;
